var map = {
	"./ca.json": "121a",
	"./de.json": "2990",
	"./en.json": "3298",
	"./es.json": "3a38",
	"./fr.json": "d823",
	"./it.json": "3e8e",
	"./no.json": "9f0b",
	"./pl.json": "643d",
	"./pt.json": "7e06",
	"./sk.json": "d050",
	"./sl.json": "8a91",
	"./sv.json": "5dac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8012";